<template>
  <div class="BrokerDashboardAnalytics">
    <div class="navbar">
      <NavBar></NavBar>
    </div>
    <div class="sideBarSection">
      <PlainSideBar v-if="isDesktop"></PlainSideBar>
    </div>

    <div v-if="isDesktop">
      <!-- v-if="user_details && user_details.is_active_ra" -->
      <div class="cover-page-container">
        <!-- Heading section -->
        <div class="flex-space-between user-details-section">
          <div class="label-lg-black-bold">
            <span class="crown-outer">
              <img src="../assets/images/Active RA - Crown Icon.svg" alt="" />
            </span>
            User Details
          </div>

          <div>
            <!-- <div style="height: 25px;">&nbsp;</div> -->
            <div
              class="flex"
              style="margin-top: 7px; align-items: baseline; justify-content: end;"
            >
              <el-button
                class="download-btn export-btn flex"
                style=""
                @click="getTotalEntriesForExport()"
                :disabled="!subscribedUsersList.length || is_export_Loading"
                :loading="is_export_Loading"
              >
                <span style="position: relative; top: -2px;">
                  Export
                  <i
                    class="el-icon-document"
                    style="font-size: 20px; margin-left: 3px; position: relative; top: 2px;"
                  ></i>
                </span>
              </el-button>
            </div>
          </div>
          <!-- <div>
             <img
               src="../assets/images/RA-dashboard/Messenger active Icon.svg"
               alt=""
             />
           </div> -->
        </div>

        <!-- Table filter section -->

        <div class="filter-section">
          <el-row :gutter="15" style="align-items: center;">
            <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
              <!-- <div
                 class="label-xs-bold right-margin-15"
                 style="margin-top: 11px;"
               >
                 Sort By:
               </div> -->
            </el-col>
            <el-col :xs="24" :sm="22" :md="22" :lg="22" :xl="22">
              <div class="flex-space-between">
                <div class="flex">
                  <div>
                    <div class="input-label-bold-gray">
                      Filter By:
                    </div>
                    <div class="flex">
                      <el-input
                        v-model="searchQuery"
                        size="mini"
                        placeholder="Email, Mobile"
                        clearable
                        style="width: 200px; margin-right: 18px;"
                        @input="filterUserData()"
                      ></el-input>
                    </div>
                  </div>

                  <div style="margin-right:20px">
                    <div class="input-label-bold-gray">
                      Past Duration:
                    </div>
                    <div class="flex">
                      <el-date-picker
                        v-model="startDate"
                        type="date"
                        placeholder="Start Date"
                        style="width: 130px; margin-right: 18px;"
                        size="mini"
                        class="custom-date-picker"
                        :default-value="defaultStartDate"
                        :picker-options="startDatePickerOptions"
                        @change="handleStartDateChange"
                      ></el-date-picker>
                      <el-date-picker
                        v-model="endDate"
                        type="date"
                        placeholder="End Date"
                        style="width: 130px"
                        size="mini"
                        class="custom-date-picker"
                        :default-value="defaultEndDate"
                        :picker-options="endDatePickerOptions"
                        @change="handleEndDateChange"
                      ></el-date-picker>
                    </div>
                  </div>

                  <div>
                    <div class="input-label-bold-gray">
                      Plan Status:
                    </div>
                    <div class="flex">
                      <el-select
                        v-model="status"
                        size="mini"
                        placeholder="Status"
                        style="width: 90px; margin-right: 18px;"
                        clearable
                        @change="filterUserData()"
                      >
                        <el-option
                          v-for="status in status_list"
                          :key="status.value"
                          :label="status.label"
                          :value="status.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <!-- <div>
                    <div class="input-label-bold-gray">
                      KYC Status:
                    </div>
                    <div class="flex">
                      <el-select
                        v-model="kycStatus"
                        size="mini"
                        placeholder="KYC Status"
                        clearable
                        style="width: 130px; margin-right: 18px;"
                        @change="filterUserData()"
                      >
                        <el-option
                          v-for="kyc in kyc_status_list"
                          :key="kyc"
                          :label="kyc"
                          :value="kyc"
                        ></el-option>
                      </el-select>
                    </div>
                  </div> -->

                  <div style="margin-top:30px;border-radius:10px; ">
                    <el-button
                      size="mini"
                      @click="clearFilters()"
                      style="border-radius: 10px;padding: 3px 10px;color:rgb(64, 158, 255);border-color:rgb(64, 158, 255);"
                      :disabled="isFilterActive() == false"
                    >
                      Reset
                    </el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div
          v-if="subscribedUsersList.length || is_user_list_loading"
          v-loading="is_user_list_loading"
        >
          <div class="board-table-outer">
            <table class="outer-board-table board-table">
              <thead>
                <tr class="main-head">
                  <th v-if="userRoles.includes('StockAnts Admin')" style="min-width: 100px">
                    Invoice
                    <!-- <span
                      ><i
                        class="el-icon-download"
                        style="font-size: 16px;
                                color: #4488d0;
                                position: relative;
                                top: 2px;
                                font-weight: 600; "
                        @click="downloadBulkDetailsPdf()"
                      ></i
                    ></span> -->
                  </th>
                  <th style="min-width: 100px;">Name</th>
                  <th v-if="userRoles.includes('StockAnts Admin')" style="min-width: 100px;">UTM Source</th>
                  <th style="min-width: 80px;">Customer Id</th>
                  <th style="min-width: 150px;">Email</th>
                  <th style="min-width: 90px;">Mobile</th>
                  <!-- <th style="min-width: 70px;">Pan</th> -->
                  <th v-if="!isRestrictedBroker" style="min-width: 90px; white-space: normal;">
                    Risk Meter
                  </th>
                  <!-- <th style="min-width: 90px;">Asset Class</th> -->
                  <th v-if="userRoles.includes('StockAnts Admin')" style="min-width: 50px;">Plan Name</th>
                  <th v-if="userRoles.includes('StockAnts Admin')" style="min-width: 50px;">Validity</th>
                  <th v-if="userRoles.includes('StockAnts Admin')" style="min-width: 50px;">Price</th>
                  <th style="min-width: 120px;">First Login</th>
                  <th
                    style="min-width: 120px; white-space: normal; cursor: pointer;"
                    @click="sortByLastLogin()"
                  >
                    Last Login
                    <i
                      v-if="sortOrder === 'asc'"
                      class="el-icon-arrow-up"
                      style="font-weight: bold;"
                    ></i>
                    <i
                      v-if="sortOrder === 'desc'"
                      class="el-icon-arrow-down"
                      style="font-weight: bold;"
                    ></i>
                  </th>
                  <th v-if="userRoles.includes('StockAnts Admin')" style="min-width: 130px;">First Subscribed</th>
                  <th v-if="userRoles.includes('StockAnts Admin')" style="min-width: 130px;">Latest Subscribed</th>
                  <th v-if="!isRestrictedBroker" style="min-width: 120px; white-space: normal;">
                    Number of times Plan Subscribed
                  </th>
                  <th v-if="!isRestrictedBroker" style="min-width: 120px; white-space: normal;">
                    Number of times user Login
                  </th>
                  <!-- <th style="min-width: 90px; white-space: normal;">
                    Number of Device Used
                  </th> -->
                  <th v-if="userRoles.includes('StockAnts Admin')" style="min-width: 50px;">Status</th>
                  <th
                    style="min-width: 70px; color:#4488d0"
                    class="text-center fixed-column"
                  >
                    WhatsApp
                    <span class="shadow"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in sortedUsersList" :key="index">
                  <td v-if="userRoles.includes('StockAnts Admin')" class="text-center">
                    <div
                      @click="downloadPdf(data.invoice_url)"
                      v-if="data.invoice_no"
                      class="external-link-color"
                      style="text-decoration: underline; cursor: pointer;"
                    >
                      {{ data.invoice_no }}
                    </div>
                    <div v-else>
                      --
                    </div>
                  </td>
                  <td>{{ data.user_name || "--" }}</td>
                  <td v-if="userRoles.includes('StockAnts Admin')">{{ data.utm_source || "--" }}</td>
                  <td>{{ data.cust_id || "--" }}</td>
                  <td>
                    <div
                      @click="handleEmailClick(data.email)"
                      v-if="data.email"
                      class="external-link-color"
                      style="text-decoration: underline; cursor: pointer;"
                    >
                      {{ data.email }}
                    </div>
                    <div v-else>
                      --
                    </div>
                  </td>
                  <td>{{ data.mobile || "--" }}</td>
                  <!-- <td>{{ data.pan_number || "--" }}</td> -->
                  <td v-if="!isRestrictedBroker">{{ data.risk_meter || "--" }}</td>
                  <td v-if="userRoles.includes('StockAnts Admin')">{{ data.plan_name || "--" }}</td>
                  <td v-if="userRoles.includes('StockAnts Admin')">{{ data.plan_validity || "--" }}</td>
                  <td v-if="userRoles.includes('StockAnts Admin')">{{ data.plan_amount || "--" }}</td>
                  <td>
                    {{
                      data.user_first_login
                        ? moment(data.user_first_login).format(
                            "MMM DD YYYY, h:MM A"
                          )
                        : "--"
                    }}
                  </td>
                  <td>
                    {{
                      data.user_last_login
                        ? moment(data.user_last_login).format(
                            "MMM DD YYYY, h:MM A"
                          )
                        : "--"
                    }}
                  </td>
                  <td v-if="userRoles.includes('StockAnts Admin')">
                    {{
                      data.first_subscription_datetime
                        ? moment(data.first_subscription_datetime).format(
                            "MMM DD YYYY, h:MM A"
                          )
                        : "--"
                    }}
                  </td>
                  <td v-if="userRoles.includes('StockAnts Admin')">
                    {{
                      data.latest_subscription_datetime
                        ? moment(data.latest_subscription_datetime).format(
                            "MMM DD YYYY, h:MM A"
                          )
                        : "--"
                    }}
                  </td>

                  <td v-if="!isRestrictedBroker" style="text-align: center;">
                    {{ data.no_of_times_subscribed_earlier || "--" }}
                  </td>
                  <td v-if="!isRestrictedBroker" type="text" style="text-align: center">
                    {{ data.no_of_logins || "--" }}
                  </td>

                  <!-- <td
                    @click="openDialogWithDeviceData(data.user_id)"
                    type="text"
                    class="external-link-color"
                    :style="{
                      textAlign: 'center',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      textDecoration: data.no_of_device_used
                        ? 'underline'
                        : 'none',
                    }"
                  >
                    {{ data.no_of_device_used || "--" }}
                  </td> -->

                  <td v-if="userRoles.includes('StockAnts Admin')" :class="data.plan_status == 'Live' ? 'live' : 'expired'">
                    {{ data.plan_status || "--" }}
                  </td>
                  <td class="flex-center fixed-column">
                    <img
                      src="../assets/images/whatsapp 1.png"
                      width="25px"
                      alt=""
                      @click="openWhatsApp(data.mobile)"
                    />
                    <span class="shadow"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="pagination" style="text-align:center">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pagination.current_page"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pagination.page_size"
              :total="pagination.total_entries"
              :pager-count="5"
              layout="total, prev, pager, next"
            ></el-pagination>
          </div>
        </div>
        <div v-if="!is_user_list_loading && !subscribedUsersList.length">
          <NoDataFound></NoDataFound>
        </div>
      </div>

      <!-- Below dialog for user login details -->
      <!-- <el-dialog :visible.sync="dialogTableVisible" title="User Login Details" class="custom-dialog">
    <el-table :data="dialogTableData" v-loading="is_user_login_details_loading">
      <el-table-column prop="datetime" label="Date and Time"></el-table-column>
    </el-table>
    <div class="pagination" style="text-align:center; margin-top: 20px;">
      <el-pagination
        @current-change="handleDialogCurrentChange"
        :current-page="dialogPagination.current_page"
        :page-size="dialogPagination.page_size"
        :total="dialogPagination.total_entries"
        :pager-count="5"
        layout="prev, pager, next"
      ></el-pagination>
    </div>
  </el-dialog> -->

      <!-- Below dialog for user Device details -->
      <el-dialog
        :visible.sync="dialogDeviceTableVisible"
        title="User Device Details"
        class="custom-dialog"
        :width="'70%'"
      >
        <div
          v-if="dialogDeviceTableData.length || is_device_list_loading"
          v-loading="is_device_list_loading"
        >
          <el-table
            :data="dialogDeviceTableData"
            v-loading="is_device_list_loading"
          >
            <el-table-column
              prop="device_unique_id"
              label="Device Unique ID"
              min-width="250px"
            ></el-table-column>
            <el-table-column
              prop="platform"
              label="Platform"
              min-width="180px"
            ></el-table-column>
            <el-table-column
              prop="timezone"
              label="Timezone"
              min-width="180px"
            ></el-table-column>
            <el-table-column
              prop="device_type"
              label="Device Type"
              min-width="180px"
            ></el-table-column>
          </el-table>
          <div class="pagination" style="text-align:center; margin-top: 20px;">
            <el-pagination
              @current-change="handleDeviceDialogCurrentChange"
              :current-page="devicePagination.current_page"
              :page-size="devicePagination.page_size"
              :total="devicePagination.total_entries"
              :pager-count="5"
              layout="prev, pager, next"
            ></el-pagination>
          </div>
        </div>
        <div v-if="!is_device_list_loading && !dialogDeviceTableData.length">
          <NoDataFound></NoDataFound>
        </div>
      </el-dialog>
    </div>

    <div v-else>
      <div class="cover-page-container">
        <div class="block-mob-view">
          To access the Dashboard Analytics, please log in via desktop for an
          enhanced user experience.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
import { serverAddr, serverHostName, serverAddrForCSV } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import PlainSideBar from "@/components/PlainSideBar.vue";
import Hexagon from "@/components/Hexagon.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import { required } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";
import { HelperNetworkCallBack } from "../mixins/Helper";
import moment from "moment";
import NoDataFound from "@/components/NoDataFound.vue";
import NavBar from "@/components/NavBar.vue";
import ExcelJS from "exceljs";

export default {
  name: "BrokerDashboardAnalytics",

  mixins: [filterCallBack, screenSize, HelperNetworkCallBack],

  components: {
    PlainSideBar,
    Hexagon,
    NavBar,
    NoDataFound,
  },

  data() {
    return {
      nav_title: "Expert's Analytics",
      serverHostName: serverHostName,
      moment: moment,
      dateRange: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
      userRoles: localStorage.getItem("userRoles")
        ? localStorage.getItem("userRoles")
        : [],
      subscribedUsersList: [],

      status_list: [
        { label: "Live", value: "Live" },
        { label: "Expired", value: "Expired" },
      ],
      status: "",
      pagination: [],
      currentPage: 1,
      startDate: "", // no preselected date
      endDate: "", // no preselected date
      defaultStartDate: new Date(
        new Date().setMonth(new Date().getMonth() - 1)
      ), // default view of the previous month
      defaultEndDate: new Date(), // default view of the current month,
      // endDatePickerOptions: {
      //   disabledDate(time) {
      //     return time > new Date(); // disable dates in the future
      //   }
      // },
      active_period: "1M",
      period_list: [
        {
          label: "1 Month",
          value: "1M",
        },
        {
          label: "3 Month",
          value: "3M",
        },
        {
          label: "6 Month",
          value: "6M",
        },
        {
          label: "1 Year",
          value: "1Y",
        },
      ],
      kycStatus: "",
      kyc_status_list: ["KYC Verified", "KYC Not Verified"],
      is_user_list_loading: false,
      is_export_Loading: false,
      exportUserList: [],
      // selected_broker.id: "",
      selectedEmail: "",
      searchQuery: "",
      client_id: "",
      // dialogTableVisible: false,
      // dialogTableData: [],
      // dialogPagination: {
      //   current_page: 1,
      //   page_size: 5,
      //   total_entries: 0,
      // },
      // selected_user_id: null,

      dialogDeviceTableVisible: false,
      dialogDeviceTableData: [],
      devicePagination: {
        current_page: 1,
        page_size: 5,
        total_entries: 0,
      },
      // is_user_login_details_loading: false,
      is_device_list_loading: false,
      selected_user_id: null,
      subscribedUsersList: [],
      sortOrder: "desc",
    };
  },

  validations: {
    review: {
      required,
    },
  },

  mounted() {
    // Call getSubscribedUsersList initially if selected_broker is already set
    if (this.selected_broker) {
      this.getSubscribedUsersList();
    }
  },
  watch: {
    // selected_broker(newValue, oldValue) {
    //   if (newValue) {
    //     // clearFilters and get all data
    //     this.clearFilters();
    //   }
    // },
    selected_broker(newBroker, oldBroker) {
      if (newBroker && (!oldBroker || newBroker.id !== oldBroker.id)) {
        this.clearFilters();
      }
    },
    user_details(newValue, oldValue) {
      if (
        newValue &&
        newValue.mark_as_verified &&
        newValue.is_active_ra &&
        this.isDesktop
      ) {
        this.getSubscribedUsersList();
      }
    },
    startDate(newValue, oldValue) {
      if (newValue) {
        this.startDate = this.formatDate(newValue);
      }
      if (newValue == null) {
        this.startDate = "";
      }
    },
    endDate(newValue, oldValue) {
      if (newValue) {
        this.endDate = this.formatDate(newValue);
      }
      if (newValue == null) {
        this.endDate = "";
      }
    },
  },

  methods: {
    sortByLastLogin() {
      // Toggle sorting order between asc and desc
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
    },

    // Below methods for User Login details
    // openDialogWithUserData(user_id) {
    //   this.selected_user_id = user_id;
    //   this.dialogTableVisible = true;
    //   this.getUserLoginDetails(
    //     user_id,
    //     this.dialogPagination.current_page,
    //     this.dialogPagination.page_size
    //   );
    // },
    // getUserLoginDetails(user_id, page, pageSize) {
    //   this.is_user_login_details_loading = true;

    //   const queryParams = new URLSearchParams({
    //     user_id: user_id,
    //     page_no: page,
    //     page_per_entries: pageSize,
    //   });

    //   serverAddr
    //     .get(`/auth/admin/v1/user_login_details?${queryParams.toString()}`)
    //     .then((response) => {
    //       if (response.data.status) {
    //         this.dialogTableData = response.data.data;
    //         this.dialogPagination.total_entries =
    //           response.data.pagination.total_entries;
    //       } else {
    //         this.dialogTableData = [];
    //         this.dialogPagination.total_entries = 0;
    //       }
    //       setTimeout(() => {
    //         this.is_user_login_details_loading = false;
    //       }, 100);
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching user data:", error);
    //       this.dialogTableData = [];
    //       this.dialogPagination.total_entries = 0;
    //       this.is_user_login_details_loading = false;
    //     });
    // },
    // handleDialogCurrentChange(page) {
    //   this.dialogPagination.current_page = page;
    //   this.getUserLoginDetails(
    //     this.selected_user_id,
    //     page,
    //     this.dialogPagination.page_size
    //   );
    // },
    // handleDialogSizeChange(pageSize) {
    //   this.dialogPagination.page_size = pageSize;
    //   this.getUserLoginDetails(
    //     this.selected_user_id,
    //     this.dialogPagination.current_page,
    //     pageSize
    //   );
    // },

    // Below methods for Device details
    openDialogWithDeviceData(user_id) {
      this.selected_user_id = user_id;
      this.dialogDeviceTableVisible = true;
      this.getDeviceData(
        user_id,
        this.devicePagination.current_page,
        this.devicePagination.page_size
      );
    },
    getDeviceData(user_id, page, pageSize) {
      this.is_device_list_loading = true;

      const queryParams = new URLSearchParams({
        user_id: user_id,
        page_no: page,
        page_per_entries: pageSize,
      });

      serverAddr
        .get(`/auth/admin/v1/user_device_details?${queryParams.toString()}`)
        .then((response) => {
          // console.log("Response data:", response.data);
          if (response.data.status) {
            this.dialogDeviceTableData = response.data.data;
            this.devicePagination.total_entries =
              response.data.pagination.total_entries;
          } else {
            this.dialogDeviceTableData = [];
            this.devicePagination.total_entries = 0;
          }
          setTimeout(() => {
            this.is_device_list_loading = false;
          }, 100);
        })
        .catch((error) => {
          console.error("Error fetching device data:", error);
          this.dialogDeviceTableData = [];
          this.devicePagination.total_entries = 0;
          this.is_device_list_loading = false;
        });
    },
    handleDeviceDialogCurrentChange(page) {
      this.devicePagination.current_page = page;
      this.getDeviceData(
        this.selected_user_id,
        page,
        this.devicePagination.page_size
      );
    },
    handleDeviceDialogSizeChange(pageSize) {
      this.devicePagination.page_size = pageSize;
      this.getDeviceData(
        this.selected_user_id,
        this.devicePagination.current_page,
        pageSize
      );
    },

    redirectToUserPlans() {
      this.$router.push("/user-plans");
    },

    downloadBulkDetailsPdf() {
      // https://dev-api.stockants.com/api/my_dashboard/v1/sa/download_invoice_SA_Dashboard?status=Live&start_date=2024-03-01&end_date=2024-05-01&kyc_status=true'

      var linkForDownload = `${
        this.serverHostName
      }/api/my_dashboard/v1/sa/download_invoice_SA_Dashboard?`;
      linkForDownload = this.status.length
        ? linkForDownload + "status=" + this.status
        : linkForDownload;
      linkForDownload = this.startDate
        ? linkForDownload + "&start_date=" + this.startDate
        : linkForDownload;
      linkForDownload = this.endDate
        ? linkForDownload + "&end_date=" + this.endDate
        : linkForDownload;

      linkForDownload = this.kycStatus.length
        ? linkForDownload + "&kyc_status=" + this.kycStatus
        : linkForDownload;

      linkForDownload = this.selected_broker
        ? linkForDownload + "&broker=" + this.selected_broker.id
        : linkForDownload;
    },
    openWhatsApp(mobile) {
      if (mobile != null) {
        var whatsappURL;
        if (window.innerWidth < 992) {
          // Construct the WhatsApp URL
          whatsappURL = `https://wa.me/${mobile}`;
        } else {
          whatsappURL = `https://web.whatsapp.com/send?phone=${mobile}`;
        }

        // Open the WhatsApp URL
        var newWindow = window.open(whatsappURL, "_blank");

        // Check if a new tab was opened
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed == "undefined"
        ) {
          // If the window was blocked or closed, prompt the user to check their browser settings
          alert(
            "WhatsApp window was blocked or closed. Please check your browser settings to allow pop-ups or manage tabs."
          );
        }
      } else {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: "Mobile number not present",
          type: "error",
          duration: 3,
        });
      }
    },
    async checkLoginUserDetail() {
      const computedValue = this.user_details;
      if (
        computedValue &&
        computedValue.mark_as_verified &&
        computedValue.is_active_ra
      ) {
        this.getSubscribedUsersList();
      }
    },

    handleStartDateChange(val) {
      if (this.endDate && new Date(val) > new Date(this.endDate)) {
        this.endDate = val;
      }
      if (this.startDate && this.endDate) {
        this.getSubscribedUsersList();
      }
    },
    handleEndDateChange(val) {
      if (
        val != null &&
        this.startDate &&
        new Date(val) < new Date(this.startDate)
      ) {
        this.startDate = val;
      }
      if (this.startDate && this.endDate) {
        this.getSubscribedUsersList();
      }
    },

    openStartDatePicker() {
      // Open the date picker with the past month visible
      const datePicker = this.$refs.startDatePicker;
      const prevMonth = new Date();
      prevMonth.setMonth(prevMonth.getMonth() - 1);
      datePicker.$refs.picker.currentView.date.setMonth(prevMonth.getMonth());
      datePicker.$refs.picker.currentView.date.setFullYear(
        prevMonth.getFullYear()
      );
      datePicker.$refs.picker.handleDatePick({
        type: "month",
        value: prevMonth,
      });
    },
    openEndDatePicker() {
      // Open the date picker with the current month visible
      const datePicker = this.$refs.endDatePicker;
      const currentMonth = new Date();
      datePicker.$refs.picker.currentView.date.setMonth(
        currentMonth.getMonth()
      );
      datePicker.$refs.picker.currentView.date.setFullYear(
        currentMonth.getFullYear()
      );
      datePicker.$refs.picker.handleDatePick({
        type: "month",
        value: currentMonth,
      });
    },
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },

    filterUserData() {
      this.currentPage = 1;
      this.getSubscribedUsersList();
    },

    handleEmailClick(email) {
      this.selectedEmail = email;
      this.filterUserData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSubscribedUsersList();
    },

    downloadPdf(path) {
      window.open(`${this.serverHostName + "/" + path}`, "_blank");
    },

    async downloadExcel() {
      try {
        // Fields to remove
        const fieldsToRemove = ["plan_name", "invoice_url"];

        // Remove specified fields from each object in the array
        const newData = this.exportUserList.map((obj) => {
          const newObj = { ...obj }; // Create a shallow copy of the original object
          fieldsToRemove.forEach((field) => {
            delete newObj[field]; // Delete the specified field from the copied object
          });
          return newObj; // Return the modified object
        });

        const data = newData;
        // Create a new workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        // Add headers
        const headers = Object.keys(data[0]);
        worksheet.addRow(headers);

        // Add data to worksheet
        data.forEach((item) => {
          const rowValues = headers.map((header) => item[header]);
          worksheet.addRow(rowValues);
        });

        // Set column widths
        ["A", "B", "D", "G", "K"].forEach((column) => {
          worksheet.getColumn(column).width = 18; // Example width
        });

        ["C", "H", "I", "L", "M"].forEach((column) => {
          worksheet.getColumn(column).width = 28; // Example width
        });

        ["D", "E", "F", "J", "N"].forEach((column) => {
          worksheet.getColumn(column).width = 14; // Example width
        });

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        // Create Blob
        const blob = new Blob([buffer], { type: "application/octet-stream" });

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "StockAnts User Subscription List.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error exporting to Excel:", error);
      }
      setTimeout(() => {
        this.is_export_Loading = false;
      }, 100);
    },

    clearFilters() {
      this.selectedDateRange = [];
      this.startDate = "";
      this.endDate = "";
      this.status = "";
      this.kycStatus = "";
      // this.$store.commit("commitSelectedBroker", null);
      this.currentPage = 1;
      this.selectedEmail = "";
      this.searchQuery = "";
      this.filterUserData();
    },
    isFilterActive() {
      if (
        (this.startDate && this.startDate.length) ||
        (this.endDate && this.endDate.length) ||
        this.status.length ||
        this.selectedEmail.length ||
        this.kycStatus.length ||
        this.searchQuery.length
      ) {
        return true;
      } else {
        return false;
      }
    },

    getSubscribedUsersList() {
      this.is_user_list_loading = true;

      var obj = {};
      obj.page_no = this.currentPage;
      obj.page_per_entries = 10;
      obj.status = this.status == "All" ? "" : this.status;
      obj.start_date = this.startDate;
      obj.end_date = this.endDate;
      obj.kyc_status = this.kycStatus;
      obj.is_export = false;
      obj.email_id = this.selectedEmail;
      obj.client_id = this.selected_broker ? this.selected_broker.id : 0;
      obj.q = this.searchQuery;

      serverAddr
        .post("/auth/admin/v1/broker_admin_dashboard", obj)
        .then((response) => {
          if (response.data.status) {
            this.subscribedUsersList = response.data.data;
            this.pagination = response.data.pagination;
          } else {
          }
          setTimeout(() => {
            this.is_user_list_loading = false;
          }, 100);
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_user_list_loading = false;
          }.bind(this)
        );
    },
    getTotalEntriesForExport() {
      if (!this.exportUserList.length) {
        var obj = {};
        obj.page_no = 1;
        obj.page_per_entries = this.pagination.total_entries;
        obj.status = this.status == "All" ? "" : this.status;
        obj.start_date = this.startDate;
        obj.end_date = this.endDate;
        obj.kyc_status = this.kycStatus;
        obj.is_export = false;
        obj.email_id = this.selectedEmail;
        obj.client_id = this.selected_broker ? this.selected_broker.id : 0;
        obj.q = this.searchQuery;

        serverAddr
          .post("/auth/admin/v1/broker_admin_dashboard", obj)
          .then((response) => {
            if (response.data.status) {
              this.exportUserList = response.data.data;
              this.downloadExcel();
            } else {
            }
          })
          .catch(
            function(error) {
              console.log(error);
            }.bind(this)
          );
      } else {
        this.downloadExcel();
      }
    },

    downloadBulkDetailsPdf() {
      var obj = {};
      obj.page_no = 1;
      obj.page_per_entries = this.pagination.total_entries;
      obj.status = this.status == "All" ? "" : this.status;
      obj.start_date = this.startDate;
      obj.end_date = this.endDate;
      obj.kyc_status = this.kycStatus;
      obj.is_export = false;
      obj.email_id = this.selectedEmail;

      serverAddr
        .post("/my_dashboard/v1/sa/download_invoice_for_SA_Dashboard", obj)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "bulk_invoice.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  computed: {
    sortedUsersList() {
      // Sort subscribedUsersList based on user_last_login and sortOrder
      return this.subscribedUsersList.slice().sort((a, b) => {
        const dateA = moment(a.user_last_login);
        const dateB = moment(b.user_last_login);

        if (this.sortOrder === "asc") {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      });
    },
    selected_broker() {
      return this.$store.state.selected_broker
        ? this.$store.state.selected_broker
        : null;
    },

    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    // return user details e.g. accuracy, success rate, rating etc.
    user_details() {
      return this.$store.state.user_details;
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },

    startDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.endDate) {
            return (
              time.getTime() > now.getTime() ||
              time.getTime() > new Date(this.endDate).getTime()
            );
          }
          return time.getTime() > now.getTime();
        },
      };
    },
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.startDate) {
            return (
              time.getTime() < new Date(this.startDate).getTime() ||
              time.getTime() > now.getTime()
            );
          }
          return time.getTime() > now.getTime();
        },
      };
    },
    isRestrictedBroker() {
      const title = this.selected_broker && this.selected_broker.title;
      return title === "Navia" || title === "Navia trade";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.BrokerDashboardAnalytics {
  min-height: calc(100vh - 60px);
  background-color: $page-background-color;
  padding: 60px 0 0 0;

  .block-mob-view {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    color: $secondary-theme-color;
    font-weight: 600;
    padding: 20px;
    text-align: center;
  }
  .outer {
    background-color: #feffe5;
    text-align: center;
    padding: 10px 0px 20px;
    width: calc(100% - 265px);
    margin-left: 265px;
  }
  .marquee-container img {
    max-height: 35px;
    margin-right: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // Below css for Marquee tag
  marquee {
    height: 100px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: center;
  }

  @keyframes marquee {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(-100%);
    }
  }
  .cover-page-container {
    .export-btn {
      font-size: 12px;
      padding: 4px 10px;
      margin-left: 8px;
    }
    .board-table-outer {
      border-top: 4px solid #bea66e;
      overflow-x: auto;
      min-height: 370px;

      .live {
        color: #079e3e;
      }

      .expired {
        color: #e72726;
      }
      .download-btn {
        padding: 5px 8px;
        font-size: 12px;
        width: 15px;
        margin: 0 auto;
        box-shadow: 0px 1px 3px 1px #e0e0e0;
      }
      .sub-section {
        padding: 0 !important;
      }
      .sub-sec-head {
        width: 100%;
        text-align: left;
        background-color: #2d2e8d;
        padding: 10px;
        color: #ffff;
        margin: 10px 0 0;
        font-weight: 600;
      }
    }
    .center-content {
      text-align: center;
      vertical-align: middle;
    }

    .loader-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.8);
      z-index: 10;
    }

    .date-range-picker-wrapper {
      width: 300px;
    }

    .date-range-picker {
      width: 100%;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 16px;
    }
    .board-table {
      overflow-x: auto;
      border-spacing: 0;
      border-collapse: collapse;
      width: 100%;
      text-align: left;

      .main-head th {
        color: #000;
      }

      .border-right-gray {
        border-right: 1px solid #e9e9e9;
      }
      .border-bottom-gray {
        border-bottom: 1px solid #e9e9e9;
      }
      .bottom-spacing-table-heading {
        padding: 0px 8px 8px 8px;
      }
      thead {
        tr {
          th {
            color: #a5a6a8;
            font-size: 0.8rem;
            font-weight: 700;
            padding: 10px 15px;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: break-word;
          }
        }

        tr:nth-child(1) {
          border-bottom: 1px solid #e9e9e9;
          background-color: #ededed;
        }
      }
      tbody {
        // min-height: 300px;
        tr {
          // cursor: pointer;
          td {
            font-size: 0.7rem;
            font-weight: 500;
            padding: 0px 15px;
            // vertical-align: unset;
          }
        }
        // tr:hover {
        //   background-color: #eff5fe;
        // }

        tr:nth-child(even) td {
          background-color: #f1f7f8; /* Set background color for even rows */
        }
      }
      td.fixed-column,
      th.fixed-column {
        position: sticky;
        right: -1px; /* Fix column to the right */
        z-index: 1;
        background-color: #ffff;
        border-bottom: none;
        height: 23px;
        border-left: 1px solid #dcdcdc !important;
        box-shadow: -4px 1px 5px -3px #00000080;
        margin: 0;
        padding: 8px;
      }
    }

    .el-range-editor.el-input__inner {
      margin-right: 20px;
    }
    .pagination {
      margin: 15px 0 10px;
    }
    .user-details-section {
      border-bottom: 1px solid #d5d5d5;
      padding: 10px 20px;
    }

    .crown-outer {
      background: #bea66e;
      padding: 2px 5px;
      border-radius: 5px;
      margin-right: 3px;
    }
    .filter-section {
      padding: 0 20px;
      margin-bottom: 15px;
    }
  }
  .cover-page-container {
    width: calc(100% - 295px);
    margin-left: 280px;
    margin-top: 15px;
    padding-bottom: 10px;
    // padding: 20px 0;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 1px #dcd6d6;
    margin-bottom: 50px;
  }

  .footer-section {
    width: calc(100% - 260px);
    margin-left: 260px;
  }

  @media screen and (max-width: 1283px) {
    .cover-page-container,
    .footer-section {
      width: 100%;
      margin-left: 0;
      height: calc(100vh - 160px);
      margin-top: 15px;
    }
    .cover-page-container {
      //   padding: 20px 10px 0 10px;
    }
    .sideBarSection {
      display: none;
    }
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.BrokerDashboardAnalytics {
  .NoDataFound {
    padding: 15px 0 0 0;
  }
  .review-card {
    border-radius: 10px;
    .el-card__body {
      padding: 5px 20px;
    }
  }
  .analytics-card {
    border-radius: 10px;
  }

  .review-section,
  .user-access-section {
    .el-rate__icon {
      font-size: 14px !important;
      margin-right: 2px;
    }
  }

  .referal-dialog {
    .el-dialog__header .el-dialog__title {
      color: #000;
      font-weight: 500;
    }
  }

  @media screen and (max-width: 992px) {
    .referal-dialog {
      width: 80% !important;
    }
  }
}
// Below css for user login & device details dialog box of
.custom-dialog .el-dialog__header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #ebeef5;
  padding: 20px;
}

.custom-dialog .el-dialog__body {
  padding: 10px 20px;
}

.custom-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
}

.custom-dialog .el-dialog {
  border-radius: 10px;
  overflow: hidden;
}

.custom-dialog .el-table {
  width: auto;
}

.custom-dialog .el-table th {
  text-align: left;
  padding: 10;
}
.custom-dialog .el-table td {
  text-align: left;
  padding: 0;
}

.custom-dialog .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.custom-dialog {
  width: 100%;
}
</style>
